'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactFontawesome = require('@fortawesome/react-fontawesome');
var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
var _faChevronRight = require('@fortawesome/fontawesome-free-solid/faChevronRight');
var _faChevronRight2 = _interopRequireDefault(_faChevronRight);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var NextButton = function NextButton(props) {
  return _react2.default.createElement('a', {
    className: 'btn btn--next ' + props.className,
    href: props.link,
    onClick: props.onClick,
    'aria-label': props.ariaLabel
  }, _react2.default.createElement('span', {
    className: 'btn__title'
  }, props.title), props.icon ? props.icon : _react2.default.createElement(_reactFontawesome2.default, {
    className: 'btn__icon btn__icon--next',
    icon: _faChevronRight2.default
  }));
};
NextButton.defaultProps = {
  ariaLabel: 'Next Recipe',
  className: '',
  icon: null,
  onClick: function onClick() {
    return false;
  },
  title: 'Next'
};
NextButton.propTypes = {
  ariaLabel: _propTypes2.default.string,
  className: _propTypes2.default.string,
  icon: _propTypes2.default.node,
  link: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func,
  title: _propTypes2.default.string
};
exports.default = NextButton;